if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /** Form Interaction
         * Interaction between form elements (typically to show/hide elements under certain conditions)
         *
         * @param form - jquery representation of container element
         *  - Add attribute [data-forminteraction-reference-date] on form to change use this as reference date
         *    (can be date dd-mm-yyyy of reference id to date input field)
         *  - Add attribute [data-only-visible-if=#id-of-target-element=expected-value] on child element to trigger conditional show/hide of element
         *    Multiple (additional) conditions are separated with && (e.g. data-only-visible-if="#id=value&&#id2=value&&[etc...]")
         *    Trigger can have multiple values, separate values with || (e.g. data-only-visible-if="#id=value1||value2")
         *  - Add attribute [data-disable-if=#id-of-target-element=expected-value] - same as data-only-visible-if, but disables target if condition is true
         */
        ZZ.FormInteraction = function(form) {
            var base = this;
            base.form = form;
            base.dependentOnlyVisibleIfElems = base.form.find(
                "[data-only-visible-if]"
            );
            base.dependentDisableIfElems = base.form.find("[data-disable-if]");
            base.triggers = [];

            base.dependentOnlyVisibleIfElems.each(function() {
                var curElem = $(this);
                base.handleOnlyVisibleIfConditions(curElem);
            });

            base.dependentDisableIfElems.each(function() {
                var curElem = $(this);
                base.handleDisableIfConditions(curElem);
            });

            base.assignListeners();

            // scroll to elements that needs focus (has classname 'focus')
            base.focusViewOnElement($(".focus"));
        };

        ZZ.FormInteraction.prototype = {
            assignListeners: function() {
                var base = this;

                // check all elements if reference date is changed
                if (
                    typeof base.form.attr(
                        "data-forminteraction-reference-date"
                    ) !== "undefined"
                ) {
                    var dateElem = $(
                        base.form.attr("data-forminteraction-reference-date")
                    );
                    if (dateElem.length > 0) {
                        dateElem.on("change", function(e) {
                            base.referenceDateChanged(dateElem);
                        });
                    }
                }
            },

            handleOnlyVisibleIfConditions: function(target) {
                var base = this,
                    actionString = target.attr("data-only-visible-if"),
                    actionTriggers = base.subdivideActions(actionString);

                // new handler to handle trigger events for this target
                base.triggers.push(
                    new ZZ.FormInteraction.ElementInteractionHandler(
                        target,
                        actionTriggers,
                        base.form,
                        "visible"
                    )
                );
            },

            handleDisableIfConditions: function(target) {
                var base = this,
                    actionString = target.attr("data-disable-if"),
                    actionTriggers = base.subdivideActions(actionString);

                // new handler to handle trigger events for this target
                base.triggers.push(
                    new ZZ.FormInteraction.ElementInteractionHandler(
                        target,
                        actionTriggers,
                        base.form,
                        "disable"
                    )
                );
            },

            subdivideActions: function(actionString) {
                var actionItems = actionString.split("&&"),
                    actionItemsLength = actionItems.length,
                    actionTriggerCollection = {};
                var i, curAction, trigger, source, condition;

                for (i = 0; i < actionItemsLength; i++) {
                    // split each action in trigger elem and expected corresponding value
                    curAction = actionItems[i].split("=");
                    trigger = source = $(curAction[0]);
                    // if radio button, take whole group of radio buttons
                    if (trigger.attr("type") === "radio") {
                        trigger = $('[name="' + trigger.attr("name") + '"]');
                    }
                    condition = curAction[1];
                    if (
                        typeof actionTriggerCollection[source.attr("id")] ===
                        "undefined"
                    ) {
                        actionTriggerCollection[source.attr("id")] = {
                            source: $(curAction[0]),
                            trigger: trigger,
                            conditions: [condition]
                        };
                    } else {
                        actionTriggerCollection[
                            source.attr("id")
                        ].conditions.push(condition);
                    }
                }
                return actionTriggerCollection;
            },

            focusViewOnElement: function(element) {
                if (element.length > 0) {
                    $("html, body").scrollTop(
                        element.first().offset().top - 200
                    );
                    return true;
                }
                return false;
            },

            referenceDateChanged: function(dateElem) {
                var base = this;

                // trigger all action triggers once, because reference date could be of influence
                $.each(base.triggers, function() {
                    $.each(this.actionTriggers, function() {
                        var curTrigger = this.trigger;
                        if (
                            curTrigger[0] !== dateElem[0] &&
                            curTrigger.is(":visible") &&
                            !curTrigger.attr("data-is-triggered")
                        ) {
                            curTrigger.attr("data-is-triggered", "true");
                            curTrigger.trigger(
                                "change.ElementInteractionHandler"
                            );
                        }
                    });
                });

                $("[data-is-triggered]").removeAttr("data-is-triggered");
            }
        };

        /**
         *  Object for handling change events for a specific target
         *
         * @param target - target element containing only-visible-if condition
         * @param actionTriggers - collection of triggers and corresponding conditions
         * @param form - main form container element
         * @param kind - kind of action to be preformed if condition is true (one of ['visible', 'disable'], default 'visible')
         */
        ZZ.FormInteraction.ElementInteractionHandler = function(
            target,
            actionTriggers,
            form,
            kind
        ) {
            var base = this;
            base.form = form;
            base.target = target;
            base.actionTriggers = actionTriggers;

            // determine kind of action to be taken after interaction change
            var kindOfAction = "visible",
                possibleKinds = ["visible", "disable"];
            if (typeof kind !== "undefined" && $.inArray(kind, possibleKinds)) {
                kindOfAction = kind;
            }

            // action handlers: implement functions 'on' and 'off'
            base.actionHandler = base.getActionHandler(kindOfAction);

            // disable all inputs initially to prevent submitting when invisible
            base.target.find(":input").prop("disabled", true);
            base.assignListeners();
        };

        ZZ.FormInteraction.ElementInteractionHandler.prototype = {
            assignListeners: function() {
                var base = this;
                var curTrigger,
                    curActions,
                    curConditions,
                    curConditionsLength,
                    curCondition,
                    i,
                    result;

                $.each(base.actionTriggers, function() {
                    this.trigger.on(
                        "change.ElementInteractionHandler init",
                        function(e) {
                            result = true;

                            // Timeout is necessary to make sure any date transformations are finished handling
                            setTimeout(function() {
                                // trigger custom events for handlers on other components
                                $(window).trigger("ZZ_form-interaction");

                                // check all conditions for target
                                $.each(base.actionTriggers, function() {
                                    // all conditions must succeed, otherwise stop iteration
                                    if (!result) {
                                        return;
                                    }

                                    curActions = this;
                                    curTrigger = curActions.trigger;
                                    curConditions = curActions.conditions;
                                    curConditionsLength = curConditions.length;

                                    for (i = 0; i < curConditionsLength; i++) {
                                        curCondition = curConditions[i];
                                        result = base.confirmAction(
                                            curActions,
                                            curTrigger,
                                            curCondition
                                        );

                                        /*DEBUG console.log('%s = %s --> %s', curTrigger.attr('id'), curCondition, result);*/
                                        // break out of loop if evaluation of condition is false
                                        if (!result) {
                                            break;
                                        }
                                    }
                                });

                                /*DEBUG console.info('--- RESULT: %s ---', result);*/
                                /*DEBUG if (result) { console.warn('target', base.target); }*/
                                if (result) {
                                    base.actionHandler.on.call(base, e);
                                } else {
                                    if (e.type !== "init") {
                                        base.resetInput();
                                    }
                                    base.actionHandler.off.call(base, e);
                                }
                            }, 0);
                        }
                    );
                    // trigger init event manually on page load
                    this.trigger.trigger("init");
                });
            },

            confirmAction: function(actions, trigger, condition) {
                var base = this,
                    result,
                    dateRegExp = /^[<>!](0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-(19|20)\d\d$/,
                    orCondition = condition.split("||"),
                    curCondition;

                for (var i = 0; i < orCondition.length; i++) {
                    curCondition = orCondition[i];

                    // if the trigger is radio button or checkbox
                    if (
                        trigger.attr("type") === "radio" ||
                        trigger.attr("type") === "checkbox"
                    ) {
                        result = actions.source.is(":checked");
                        if (
                            curCondition === "unchecked" ||
                            curCondition.indexOf("!checked") === 0
                        ) {
                            result = !result;
                        }
                    }

                    // if the trigger is a copyable element, the condition evaluates the number of copies -- see copy.js for copy implementation
                    else if (
                        typeof trigger.attr("data-number-of-copies") !==
                        "undefined"
                    ) {
                        if (curCondition.indexOf("!") > -1) {
                            result =
                                trigger.attr("data-number-of-copies") !=
                                curCondition.slice(1);
                        } else {
                            result =
                                trigger.attr("data-number-of-copies") ==
                                curCondition;
                        }
                    }

                    // if trigger is selection and dependent on option count
                    else if (curCondition.indexOf("selectedIndex>0") > -1) {
                        if (curCondition.charAt(0) === "!") {
                            result = !trigger[0].selectedIndex > 0;
                        } else {
                            result = trigger[0].selectedIndex > 0;
                        }
                    }

                    // if the trigger is a date field or the condition contains an amount of years
                    else if (
                        curCondition.indexOf("years") > -1 ||
                        dateRegExp.test(curCondition)
                    ) {
                        var selectedDate = trigger.hasClass("hasDatepicker")
                                ? trigger.datepicker("getDate")
                                : base.parseToDate(trigger.val()),
                            referenceDate = new Date(),
                            thresholdDate;

                        // set reference date if one is given in data-forminteraction-reference-date attribute
                        if (
                            base.form.attr(
                                "data-forminteraction-reference-date"
                            ) !== "undefined"
                        ) {
                            var referenceDateValue = base.form.attr(
                                "data-forminteraction-reference-date"
                            );
                            if (dateRegExp.test(referenceDateValue)) {
                                referenceDate = base.parseToDate(
                                    referenceDateValue
                                );
                            } else {
                                var referenceDateElem = $(referenceDateValue);
                                if (
                                    referenceDateElem.length > 0 &&
                                    referenceDateElem[0] !== trigger[0]
                                ) {
                                    referenceDate = referenceDateElem.hasClass(
                                        "hasDatepicker"
                                    )
                                        ? referenceDateElem.datepicker(
                                              "getDate"
                                          )
                                        : base.parseToDate(
                                              referenceDateElem.val()
                                          );
                                }
                            }
                        }

                        // set threshold date
                        if (dateRegExp.test(curCondition)) {
                            thresholdDate = base.parseToDate(curCondition);
                        } else {
                            var years = parseInt(
                                curCondition.replace(/[^0-9]/g, ""),
                                10
                            ); // remove everything but numbers from the string
                            thresholdDate = selectedDate;
                            selectedDate = new Date(
                                referenceDate.getFullYear() - years,
                                referenceDate.getMonth(),
                                referenceDate.getDate()
                            );
                        }

                        if (curCondition.indexOf(">") > -1) {
                            result = selectedDate >= thresholdDate;
                        } else if (curCondition.indexOf("<") > -1) {
                            result = selectedDate < thresholdDate;
                        } else {
                            result =
                                selectedDate.valueOf() ===
                                thresholdDate.valueOf();
                        }
                    }

                    // compare if input value is equal to condition
                    else if (trigger.val() === curCondition) {
                        result = true;
                    }

                    // compare if input value is specifically not equal to a certain condition
                    else if (curCondition.indexOf("!") === 0) {
                        result = "!" + trigger.val() !== curCondition;
                    }

                    // if no comparison found for condition, then result is false
                    else {
                        result = false;
                    }

                    // only one of the conditions needs to be true for a positive result (in case of OR condition)
                    if (result) {
                        break;
                    }
                }

                return result;
            },

            getActionHandler: function(kindOfAction) {
                var base = this,
                    result;

                switch (kindOfAction) {
                    case "visible":
                        result = base.showhideTarget;
                        break;

                    case "disable":
                        result = base.enabledisableTarget;
                        break;
                }

                return result;
            },

            // action handler for 'visible'
            showhideTarget: {
                on: function(e) {
                    this.showTarget(e);
                },

                off: function(e) {
                    this.hideTarget();
                }
            },

            // action handler for 'disable'
            enabledisableTarget: {
                on: function(e) {
                    this.disableTarget();
                },

                off: function(e) {
                    this.enableTarget();
                }
            },

            showTarget: function(e) {
                var base = this;

                base.target.fadeIn(300);

                // enable the visible inputs
                base.target.find(":input").prop("disabled", true);
                base.target
                    .find(":input:visible")
                    .not("[class*=disabledBy]")
                    .prop("disabled", false);
                base.target.find("input[type=hidden]").prop("disabled", false);

                // update specific fields
                var updateFields = base.target.find("[data-update-if-visible]");
                var curField, curTarget;
                updateFields.each(function() {
                    curField = $(this);
                    curTarget = $(e.currentTarget);
                    if (
                        curField.attr("data-update-if-visible") === "year" &&
                        curTarget.hasClass("hasDatepicker")
                    ) {
                        curField.text(
                            curTarget.datepicker("getDate").getFullYear()
                        );
                    }
                });
            },

            hideTarget: function() {
                var base = this;
                base.target.fadeOut(0);
            },

            disableTarget: function() {
                var base = this;
                if (base.target.is(":input")) {
                    base.target.prop("disabled", true);
                } else {
                    base.target
                        .find(":input")
                        .prop("disabled", true)
                        .addClass("disabledByFormInteraction");
                }
            },

            enableTarget: function() {
                var base = this;
                if (base.target.is(":input")) {
                    base.target.removeClass("disabledByFormInteraction");
                    if (
                        base.target.attr("class").indexOf("disabledBy") === -1
                    ) {
                        base.target.prop("disabled", false);
                    }
                } else {
                    var curElem;
                    base.target.find(":input").each(function() {
                        curElem = $(this);
                        curElem.removeClass("disabledByFormInteraction");
                        if (
                            curElem.attr("class").indexOf("disabledBy") === -1
                        ) {
                            curElem.prop("disabled", false);
                        }
                    });
                }
            },

            // reset all inputs within target element
            resetInput: function() {
                var base = this,
                    input = base.target.find("input, select"),
                    curTag,
                    curInput,
                    initVal;

                input.each(function() {
                    curTag = this.tagName.toLowerCase();
                    curInput = $(this);

                    // don't reset value of radiobuttons, checkboxes, hidden inputs or submit buttons
                    if (
                        curTag === "input" &&
                        !curInput.is(":radio") &&
                        !curInput.is(":checkbox") &&
                        curInput.attr("type") !== "hidden" &&
                        curInput.attr("type") !== "submit"
                    ) {
                        initVal = this.getAttribute("value") || "";
                        curInput.val(initVal);
                    } else if (curTag === "select") {
                        this.selectedIndex = 0;
                    }

                    // trigger change for interaction attached to specific input
                    curInput.trigger("change.ElementInteractionHandler");
                });
                return true;
            },

            // @date - type: string, format: dd-mm-yyy
            parseToDate: function(date) {
                var splitDate = date.replace(/[^0-9-]/g, ""); // strip everything but digits and -
                splitDate = splitDate.split("-");
                if (splitDate.length === 3) {
                    return new Date(
                        splitDate[2],
                        parseInt(splitDate[1]) - 1,
                        splitDate[0]
                    ); // year, month (starts at 0), day
                } else {
                    // wrong format, return new date as fallback
                    return new Date();
                }
            }
        };
    })(jQuery);
}
